import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Newspaper, ArrowRight } from "@phosphor-icons/react";

export default function News() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/news");
      setItems(data);
      setLoading(false);
    })();
  }, []);

  return (
    <div className="pt-20 max-w-5xl mx-auto px-5 lg:px-8 pb-24" data-testid="news-page">
      <div className="mb-10">
        <div className="font-mono-accent text-xs text-[#E63946] mb-2">◢ NEWSROOM</div>
        <h1 className="font-display text-4xl lg:text-5xl font-bold tracking-tight">Notícias</h1>
        <p className="text-zinc-400 mt-2">Últimas atualizações da cena do mangá em Portugal.</p>
      </div>

      {loading ? (
        <div className="text-center font-mono-accent text-xs text-zinc-500 py-10">A CARREGAR...</div>
      ) : items.length === 0 ? (
        <div className="border border-dashed border-white/10 rounded-2xl py-20 text-center">
          <Newspaper size={42} weight="duotone" className="text-[#7209B7] mx-auto mb-3" />
          <div className="font-display font-bold text-xl">Sem notícias ainda</div>
        </div>
      ) : (
        <div className="space-y-6">
          {items.map((n) => (
            <Link
              key={n.news_id}
              to={`/noticias/${n.news_id}`}
              className="card-hover bg-[#121217] border border-white/5 rounded-2xl overflow-hidden grid md:grid-cols-[260px,1fr] group"
              data-testid={`news-${n.news_id}`}
            >
              {n.image_url ? (
                <div className="aspect-[16/10] md:aspect-auto md:h-full">
                  <img src={n.image_url} alt={n.title} className="w-full h-full object-cover" />
                </div>
              ) : <div className="hidden md:block bg-gradient-to-br from-[#7209B7]/30 to-[#E63946]/20" />}
              <div className="p-6">
                <div className="font-mono-accent text-[10px] text-zinc-500 mb-2">{new Date(n.created_at).toLocaleDateString("pt-PT", { day: "2-digit", month: "long", year: "numeric" })}</div>
                <h2 className="font-display font-bold text-2xl tracking-tight group-hover:text-[#E63946] transition-colors">{n.title}</h2>
                {n.summary && <p className="text-zinc-400 mt-2 line-clamp-3">{n.summary}</p>}
                <div className="mt-4 inline-flex items-center gap-1 text-sm text-[#E63946] font-medium">
                  Ler mais <ArrowRight size={14} weight="bold" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
